import { useEffect, useState } from "react";
import { userStore } from "entities/User/store/userStore";
import { useShallow } from "zustand/shallow";
import { getNavLinks } from "../utils/getNavLinks";
import { useTranslation } from "react-i18next";
import { useAvailableModules } from "shared/api/hooks/useAvailableModules";
import { LINKS, ROLES, ROUTES } from "shared/config";

export function useNavLinks() {
  const [
    user,
    isUserFromNorthAmerica,
    isUserSupervisor,
    isUserAdditionalAcceptor,
    isUserLocalAdmin,
    isUserAccountsPayable,
    isUserLocalHR,
    isUserAdministration,
    isUserCostGroup,
  ] = userStore(
    useShallow((state) => [
      state.user,
      state.isUserFromNorthAmerica,
      state.isUserSupervisor,
      state.isUserAdditionalAcceptor,
      state.isUserLocalAdmin,
      state.isUserAccountsPayable,
      state.isUserLocalHR,
      state.isUserAdministration,
      state.isUserCostGroup,
    ])
  );
  const { i18n } = useTranslation();
  const [routes, setRoutes] = useState({
    navbarLinks: [],
    footerLinks: [],
    drawerLinks: [],
  });
  const { data: modules } = useAvailableModules();

  function validateRoute(route) {
    if (route?.link === ROUTES.request.new_travel)
      return user?.is_travel_request_allowed;
    if (route?.link === ROUTES.cards.card_requests_queue_user)
      return modules?.user_modules?.CreditCards?.available;
    if (route?.link === ROUTES.cards.corporate_cards_requests_queue_user)
      return modules?.user_modules?.CorporateCards?.available;
    if (route?.link === ROUTES.travel_acceptor.queue)
      return isUserAdministration && user?.country_code === "PL";
    if (route?.link === ROUTES.local_admin.queue) return isUserLocalAdmin;
    if (route?.link === ROUTES.cost_group.queue) return isUserCostGroup;
    if (route?.link === ROUTES.accounts_payable.panel)
      return isUserAccountsPayable;
    if (route?.link === ROUTES.local_hr.queue)
      return isUserLocalHR && user?.country_code === "PL";
    if (route?.href === LINKS.logs)
      return user.roles.data.some((role) =>
        [ROLES.MASTER_ADMIN, ROLES.LOG_VIEWER].includes(role.name)
      );

    return true;
  }

  useEffect(() => {
    getNavLinks((translatedRoutes) => {
      const sortedRoutes = translatedRoutes.reduce(
        (acc, route) => {
          if (!validateRoute(route)) return acc;

          if (
            route?.link === ROUTES.request.user_queue &&
            isUserFromNorthAmerica
          ) {
            route = { ...route, label: "OOP Expenses" };
          }

          if (route.displayOn.includes("navbar")) acc.navbarLinks.push(route);
          if (route.displayOn.includes("drawer")) acc.drawerLinks.push(route);
          if (route.displayOn.includes("footer")) acc.footerLinks.push(route);

          return acc;
        },
        { navbarLinks: [], footerLinks: [], drawerLinks: [] }
      );

      setRoutes(sortedRoutes);
    });
  }, [
    user,
    modules,
    isUserFromNorthAmerica,
    isUserSupervisor,
    isUserAdditionalAcceptor,
    isUserLocalAdmin,
    isUserAccountsPayable,
    isUserLocalHR,
    isUserAdministration,
    isUserCostGroup,
    i18n.language,
  ]);

  return routes;
}
